import React from 'react';
import styled from 'styled-components'; 
import { useLocomotiveScroll } from 'react-locomotive-scroll';
import rot01 from '../../assets/images/14s.png';
import logo01 from '../../assets/images/logo.png';
import RhythmSignature from '../RhythmSignature';
import "./foot.css";
const SectionWrapper = styled.section`
  min-height: 90vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; 
  color: whitesmoke;
  position: relative;
`;
const Container = styled.div` 
    text-transform:uppercase;  
`; 
const LeftContainer = styled.div` 
    margin-top: -15%;
    position: absolute;
    text-transform:uppercase;  
`; 
const RightContainer = styled.div` 
    position: absolute;
    margin-top: 1%;
    text-transform:uppercase;  
    z-index: 10;
`; 

const RhythmBadgeWrapper = styled.div`
    position: absolute;
    bottom: 5vh;
    right: 5vw;
`;
const Footer = () => {
  const { scroll } = useLocomotiveScroll();

  const handleScroll = (id) => {
    let elem = document.querySelector(id);

    scroll.scrollTo(elem, {
      offset: '-100',
      duration: '2000',
      easing: [0.25, 0.0, 0.35, 1.0],
    });
  };

  return (
    <SectionWrapper>
     <Container
     data-scroll
     data-scroll-delay=".15"
     data-scroll-speed="1">

      <img src={rot01} alt="" className="rot" />
     </Container>
      <LeftContainer
       data-scroll
       data-scroll-delay=".15"
       data-scroll-speed="1">
          <a className='last-link' href="#home"><span className="sml-last">N1 </span>Home</a>
          <a className='last-link' href="#collection"><span className="sml-last">N2 </span>Collection</a>
          <a className='last-link-un' href="#roadmap"><span className="sml-last">soon </span>Mint</a>
      </LeftContainer>
      <RightContainer
       data-scroll
       data-scroll-delay=".15"
       data-scroll-speed="1">
      <a href="#home" className="credit-outbox">Remade · Made By Rhythm</a>
      </RightContainer>
      <div className="lgo">
        <img src={logo01} alt="" />
      </div>
      <RhythmBadgeWrapper>
        <RhythmSignature />
      </RhythmBadgeWrapper>
    </SectionWrapper>
  );
};

export default Footer;
